import * as AT from "data/rootActionTypes";

export const getMenuList = (state) => state.dashboard[AT.MENU_LIST];
export const getMenuImageSrc = (state) => state.dashboard[AT.MENU_IMAGE_SRC];
export const getMenuPreviewSrc = (state) => state.dashboard[AT.MENU_PREVIEW_SRC];

